import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../constants';

import { clickEvent } from '../../../utils';

import SvgComponent from '../../SvgComponent';

class LoggedOutComponent extends React.Component {
    render() {
        const { i18n, urlConnection } = this.props;
        return (
            <div className="flex-container-h flex-center-alt">
                <div className="connexion bt-popup-connexion hidden-mobonly">
                    <a
                        className="bt bt-fifth"
                        href={urlConnection}
                        onClick={clickEvent('accueil_bouton_me_connecter', 'accueil')}
                        title={i18n.LOG_IN}>
                        <React.Fragment>
                            <SvgComponent
                                src={`${STATIC_ROOT}/lock.svg`}
                                alt=""
                                width="29"
                                height="24"
                                aria-hidden="true"
                                focusable="false"
                            />
                            <span>{i18n.LOG_IN}</span>
                        </React.Fragment>
                    </a>
                </div>
            </div>
        );
    }
}

LoggedOutComponent.propTypes = {
    urlConnection: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return { i18n: state.i18n.feature.header.MEMBER_NAV };
};

export default connect(mapStateToProps)(LoggedOutComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/LoggedOutComponent.js